import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AlertProvider from './context/AlertContext';
import UserProvider from './context/UserContext';
import SEO_METATAGS from './components/SEO/Metatags';
import BlogProvider from './context/BlogContext';
import YCSTM from './YCSTM';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<SEO_METATAGS />
		<YCSTM />
		<AlertProvider>
			<BlogProvider>
				<UserProvider>
					<App />
				</UserProvider>
			</BlogProvider>
		</AlertProvider>
	</React.StrictMode>,
);
